import Choices from 'choices.js';

const odSelect = 'od-select';

function createChoicesCallback(bemModifiers = []) {
	function choicesCallback() {
		if (this.containerOuter.element) {
			this.containerOuter.element.classList.add('od-select');
			bemModifiers.forEach(modifier => {
				this.containerOuter.element.classList.add(`od-select--${modifier}`);
			});
		}
	}
	return choicesCallback;
}

export default class OdSelect {
	constructor(component, options) {
		if (!component) return;
		this.defaultOptions = {
			itemSelectText: '',
			shouldSort: false,
			callbackOnInit: createChoicesCallback,
			searchResultLimit: 1000,
			classNames: {
				containerOuter: odSelect,
				containerInner: `${odSelect}__inner`,
				bemModifiers: [],
				input: `${odSelect}__input`,
				inputCloned: `${odSelect}__input--cloned`,
				list: `${odSelect}__list`,
				listItems: `${odSelect}__list--multiple`,
				listSingle: `${odSelect}__list--single`,
				listDropdown: `${odSelect}__list--dropdown`,
				item: `${odSelect}__item`,
				itemSelectable: `${odSelect}__item--selectable`,
				itemDisabled: `${odSelect}__item--disabled`,
				itemChoice: `${odSelect}__item--choice`,
				placeholder: `${odSelect}__placeholder`,
				group: `${odSelect}__group`,
				groupHeading: `${odSelect}__heading`,
				button: `${odSelect}__button`,
				isActiveModifier: '--is-active',
			},
		};
		this.extendedOptions = this.getExtendedOptions(options);
		this.component = component;
		this.init();
	}

	getExtendedOptions(options = {}) {
		Object.assign(this.defaultOptions, options, {
			classNames: Object.assign(
				this.defaultOptions.classNames,
				options.classNames,
			),
		});

		this.defaultOptions.callbackOnInit = createChoicesCallback(
			this.defaultOptions.classNames.bemModifiers,
		);
		return this.defaultOptions;
	}

	init() {
		this.initComponent = new Choices(this.component, this.extendedOptions);
		this.component.addEventListener(
			'change',
			this.triggerBlurForComponent.bind(this),
		);
		this.component.addEventListener(
			'hideDropdown',
			this.triggerBlurForComponent.bind(this),
		);
	}

	triggerBlurForComponent() {
		let event;

		if (typeof Event === 'function') {
			event = new Event('blur');
		} else {
			event = document.createEvent('CustomEvent');
			event.initCustomEvent('blur', true, true, {});
		}

		this.component.dispatchEvent(event);
	}

	addEventListener(event, callback) {
		this.component.addEventListener(event, callback);
	}

	getActiveOuterClass() {
		const { containerOuter, isActiveModifier } =
			this.extendedOptions.classNames;
		return `${containerOuter}${isActiveModifier}`;
	}

	makeActive() {
		this.initComponent.containerOuter.element.classList.add(
			this.getActiveOuterClass(),
		);
	}

	makeInactive() {
		this.initComponent.containerOuter.element.classList.remove(
			this.getActiveOuterClass(),
		);
	}

	disable() {
		this.initComponent.disable();
	}

	enable() {
		this.initComponent.enable();
	}

	destroy() {
		this.initComponent.destroy();
	}

	clearStore() {
		this.initComponent.clearStore();
	}

	removeActiveItems() {
		this.initComponent.removeActiveItems();
	}
}
